<template>
  <div class="currencySetting">
    <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
      <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="网校LOGO" prop="logo">
            <div>
              <el-upload class="avatar-uploader-logo" action :show-file-list="false" ref="upload" :http-request="logoUploadRequest">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <img class="currencySetting-image" style="margin-left: 20px" v-if="addForm.logo" :src="addForm.logo" height="60" width="250" />
              </el-upload>
              <div class="paySetting-tips">
                图片大小不超过1M，仅支持jpg，png格式，最佳尺寸为250*60.
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="LOGO" prop="logo">
            <div>
              <el-upload class="avatar-uploader-logo" action :show-file-list="false" ref="upload" :http-request="miniLogoUploadRequest">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <img class="currencySetting-image" style="margin-left: 20px" v-if="addForm.miniLogo" :src="addForm.miniLogo" height="60" width="250" />
              </el-upload>
              <div class="paySetting-tips">
                图片大小不超过1M，仅支持jpg，png格式，最佳尺寸为250*60.
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="LOGO链接" prop="logoLink">
            <el-input v-model="addForm.logoLink" placeholder="LOGO链接" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="PC域名" prop="domain">
            <el-input v-model="addForm.domain" placeholder="PC域名" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="安卓下载地址" prop="androidDownloadUrl">
            <el-input v-model="addForm.androidDownloadUrl" placeholder="安卓下载地址" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="ios下载地址" prop="iosDownloadUrl">
            <el-input v-model="addForm.iosDownloadUrl" placeholder="ios下载地址" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="小程序二维码" prop="appletQrCode">
            <div>
              <el-upload class="avatar-uploader-logo" action :show-file-list="false" :http-request="appletQrCodeUploadRequest">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <img class="currencySetting-image" style="margin-left: 20px" v-if="addForm.appletQrCode" :src="addForm.appletQrCode" height="60" width="60" />
              </el-upload>
              <div class="paySetting-tips">
                图片大小不超过10M，仅支持jpg，png格式，最佳尺寸为100*100.
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="水印" prop="img">
            <div>
              <el-upload class="avatar-uploader-logo" action :show-file-list="false" ref="watermarkUpload" :http-request="watermarkUploadRequest">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <img class="currencySetting-image" style="margin-left: 20px" v-if="addForm.watermark" :src="addForm.watermark" height="50" width="100" />
              </el-upload>
              <div class="paySetting-tips">
                图片大小不超过1M，仅支持jpg，png格式，最佳尺寸为100*50.
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="水印位置" prop="watermarkPosition">
            <el-radio-group v-model="addForm.watermarkPosition">
              <el-radio :label="1">左上</el-radio>
              <el-radio :label="2">右上</el-radio>
              <el-radio :label="3">左下</el-radio>
              <el-radio :label="4">右下</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="显示下载二维码" prop="displayQrcode">
            <el-switch v-model="addForm.displayQrcode" :active-value="1" :inactive-value="-1" active-text="开" inactive-text="关" class="switchStyle2"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="是否允许注册" prop="allowRegistration">
            <el-switch v-model="addForm.allowRegistration" :active-value="1" :inactive-value="-1" active-text="开" inactive-text="关" class="switchStyle2"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div>
      <!-- <el-button @click="addFormBack">重置</el-button> -->
      <el-button type="primary" @click="submit()" style="margin-left: 120px">保存</el-button>
    </div>
  </div>
</template>
<script>
import { uploadOSS } from "../../upload/upload";
export default {
  data () {
    let that = this;
    return {
      editBlock: false,
      submitLoading: false,
      addForm: {
        logo: null,
        miniLogo: null,
        logoLink: null,
        domain: null,
        androidDownloadUrl: undefined,
        iosDownloadUrl: undefined,
        watermark: null,
        watermarkPosition: 1,
        displayQrcode: 1,
        allowRegistration: 1,
      },
      formLabelWidth: "120px",
      addFormRules: {
        domain: [
          {
            required: true,
            message: "请输入PC域名",
            trigger: "blur",
          },
        ],
        // type: {
        //   required: true,
        //   message: "请选择商品类型",
        //   trigger: "change"
        // },
      },
    };
  },
  methods: {
    logoUploadRequest (file) {
      console.log("file", file);
      const isJPG = file.file.type === "image/jpeg" || file.file.type === "image/png";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/png 格式!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 1) {
        this.$message.error("图片大小不能超过1M");
        return;
      } else {
        uploadOSS(file, "generalSetting").then((result) => {
          this.$set(this.addForm, "logo", result);
        });
      }
    },
    miniLogoUploadRequest (file) {
      console.log("file", file);
      const isJPG = file.file.type === "image/jpeg" || file.file.type === "image/png";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/png 格式!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 1) {
        this.$message.error("图片大小不能超过1M");
        return;
      } else {
        uploadOSS(file, "generalSetting").then((result) => {
          this.$set(this.addForm, "miniLogo", result);
        });
      }
    },
    watermarkUploadRequest (file) {
      const isJPG = file.file.type === "image/jpeg" || file.file.type === "image/png";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/png 格式!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 1) {
        this.$message.error("图片大小不能超过1M");
      } else {
        uploadOSS(file, "generalSetting").then((result) => {
          this.$set(this.addForm, "watermark", result);
        });
      }
    },
    appletQrCodeUploadRequest (file) {
      const isJPG = file.file.type === "image/jpeg" || file.file.type === "image/png";
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/png 格式!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 10) {
        this.$message.error("图片大小不能超过10M");
      } else {
        uploadOSS(file, "generalSetting").then((result) => {
          this.$set(this.addForm, "appletQrCode", result);
        });
      }
    },
    getGeneralSetting () {
      this.api.generalSetting.getGeneralSetting().then((result) => {
        if (result.success) {
          if (result.data != null) {
            this.addForm = result.data;
            this.editBlock = true;
          } else {
          }
        } else {
          this.$message.error(result.message);
        }
      });
    },
    submit () {
      if (this.submitLoading) {
        return;
      }
      this.$refs.addForm.validate((valid) => {
        this.submitLoading = true;
        if (this.editBlock) {
          this.updateGeneralSetting();
        } else {
          this.addGeneralSetting();
        }
      });
    },
    addGeneralSetting () {
      this.api.generalSetting.addGeneralSetting(this.addForm).then((result) => {
        if (result.success) {
          this.submitLoading = false;
          this.editBlock = true;
          this.$message.success(result.message);
        } else {
          this.$message.error(result.message);
        }
      });
    },
    updateGeneralSetting () {
      this.api.generalSetting.updateGeneralSetting(this.addForm).then((result) => {
        if (result.success) {
          this.submitLoading = false;
          this.$message.success(result.message);
        } else {
          this.$message.error(result.message);
        }
      });
    },
  },
  computed: {
    reqData () {
      return this.$store.state.user;
    },
  },
  mounted () {
    this.getGeneralSetting();
  },
};
</script>
<style scoped>
.avatar-uploader-logo {
  margin-top: 20px;
}

.avatar-uploader-logo .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-logo .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
}

.avatar {
  width: 60px;
  height: 60px;
  display: block;
}

.currencySetting-image {
  border-radius: 4px;
  vertical-align: bottom;
}
</style>
<style lang="less">
.el-upload {
  // display: inline-flex !important;
}
</style>



// WEBPACK FOOTER //
// src/components/setting/currencySetting.vue